import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { useAuth } from '../lib/auth/store';

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
  beforeLoad: () => {
    const state = useAuth.getState();
    if (state.initialized && state.user) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function AuthLayout() {
  return (
    <div className="min-h-screen bg-soft-stone flex flex-col">
      <div className="container-editorial py-10 flex items-center gap-2">
        <span className="inline-block w-2.5 h-2.5 rounded-full bg-deep-enterprise-green" aria-hidden />
        <span className="font-display text-feature-heading tracking-tight">mindrift</span>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <div className="bg-canvas-white rounded-md border border-hairline p-8 shadow-soft">
            <Outlet />
          </div>
          <p className="text-center text-micro text-muted-slate mt-6 text-mono">INVITE-ONLY · PRIVATE</p>
        </div>
      </div>
    </div>
  );
}
